import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, HeroLine, FadeIn } from "@/components/Reveal";
import { usePageTitle } from "@/hooks/use-page-title";

const IMG =
  "https://images.pexels.com/photos/28081549/pexels-photo-28081549.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const Eyebrow = ({ children }) => (
  <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-aspira-gold">{children}</p>
);

const About = () => {
  usePageTitle("About Us | Aspira Property Group");
  return (
    <>
      <section data-testid="about-hero" className="relative overflow-hidden">
        <div className="pointer-events-none absolute -right-40 top-0 h-[420px] w-[420px] rounded-full bg-aspira-gold/10 blur-3xl" />
        <div className="mx-auto max-w-7xl px-5 pb-16 pt-16 sm:px-8 lg:pt-24">
          <FadeIn><Eyebrow>About us</Eyebrow></FadeIn>
          <h1 className="mt-6 max-w-3xl font-serif text-4xl font-medium leading-[1.1] tracking-tight text-aspira-ink sm:text-5xl">
            <HeroLine delay={0.15}>A Straightforward</HeroLine>
            <HeroLine delay={0.3}>
              Approach to <em className="italic text-aspira-gold">Land.</em>
            </HeroLine>
          </h1>
        </div>
      </section>

      <section data-testid="about-story" className="mx-auto max-w-7xl px-5 py-14 sm:px-8 lg:pb-28">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 rounded-[2rem] border border-aspira-gold/40" />
              <img
                src={IMG}
                alt="Open vacant land in a quiet valley"
                className="relative h-[360px] w-full rounded-[1.75rem] object-cover shadow-2xl lg:h-[440px]"
              />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="space-y-5 text-sm leading-relaxed text-aspira-body sm:text-base">
              <p>
                Aspira Property Group was built around a simple idea: real estate
                transactions should be handled with clarity, integrity, and care.
                We work with landowners looking to sell and buyers searching for
                their next opportunity, aiming to make every interaction
                straightforward and professional.
              </p>
              <p>
                Our approach is built on honest communication, thoughtful
                evaluation, and respect for the people behind every property. As
                we grow, our commitment remains the same: build lasting
                relationships and create value through real estate.
              </p>
            </div>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link
                to="/sell"
                data-testid="about-cta-sell"
                className="inline-flex items-center gap-2 rounded-full bg-aspira-gold px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-aspira-goldhover"
              >
                Sell Your Land <ArrowRight size={15} />
              </Link>
              <Link
                to="/contact"
                data-testid="about-cta-contact"
                className="inline-flex items-center gap-2 rounded-full border border-aspira-ink/15 px-7 py-3.5 text-sm font-semibold text-aspira-ink transition-all duration-300 hover:border-aspira-gold hover:text-aspira-gold"
              >
                Get in Touch
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default About;
